const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Imported Content Resource for Registrations
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ImportedContentRegistrations', ['$resource', 'appConfiguration', function($resource, appConfiguration) {
    
    return $resource(appConfiguration.apiUrl + '/learn/v3/imported-content/registrations/:subresource/:subsubresource', null, {
      find: {params: {subresource: '', subsubresource:''}, method: 'GET', isArray: true},
      stats: {params: {subresource: '', subsubresource:'stats'}, method: 'GET', isArray: false},
      register: {params: {subresource: 'register', subsubresource:''}, method: 'POST', isArray: false}
    });
  }]);